import { render, staticRenderFns } from "./animateList.vue?vue&type=template&id=15fc4b3c&scoped=true&"
import script from "./animateList.vue?vue&type=script&lang=js&"
export * from "./animateList.vue?vue&type=script&lang=js&"
import style0 from "./animateList.vue?vue&type=style&index=0&id=15fc4b3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fc4b3c",
  null
  
)

component.options.__file = "animateList.vue"
export default component.exports